import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './makeStyles';

const ArrowDropIcon = ({ up }) => {
  const classes = useStyles();

  return (
    <svg className={classes.root} focusable="false" viewBox="0 0 10 24" aria-hidden="true">
      {
        up ? <path d="M7 10l5 5 5-5z" /> : <path d="M7 14l5-5 5 5z" />
      }
    </svg>
  );
};

ArrowDropIcon.propTypes = {
  up: PropTypes.bool,
};

ArrowDropIcon.defaultProps = {
  up: false,
};

export default ArrowDropIcon;
